import React, { useState, useEffect } from 'react';
import { Button } from './ui/button';
import { Instagram, Menu, X } from 'lucide-react';

export const Navigation = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setIsMobileMenuOpen(false);
    }
  };

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'glass-card shadow-lg' : 'bg-transparent'
      }`}
    >
      <div className="container mx-auto px-4">
        <div className="flex items-center justify-between h-16 md:h-20">
          {/* Logo */}
          <button
            onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
            className="text-xl md:text-2xl font-bold gradient-text hover:opacity-80 transition-opacity"
          >
            Meta Learners
          </button>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center gap-8">
            <button
              onClick={() => scrollToSection('offers')}
              className="text-sm font-medium text-muted-foreground hover:text-foreground transition-colors"
            >
              Offers
            </button>
            <button
              onClick={() => scrollToSection('how-it-works')}
              className="text-sm font-medium text-muted-foreground hover:text-foreground transition-colors"
            >
              How it works
            </button>
            <button
              onClick={() => scrollToSection('trust')}
              className="text-sm font-medium text-muted-foreground hover:text-foreground transition-colors"
            >
              Why trust us
            </button>
            <button
              onClick={() => scrollToSection('faq')}
              className="text-sm font-medium text-muted-foreground hover:text-foreground transition-colors"
            >
              FAQ
            </button>
            <button
              onClick={() => scrollToSection('contact')}
              className="text-sm font-medium text-muted-foreground hover:text-foreground transition-colors"
            >
              Contact
            </button>
          </div>

          {/* CTA Button - Desktop */}
          <div className="hidden md:block">
            <Button
              className="bg-primary hover:bg-primary-glow text-primary-foreground shadow-elegant font-medium"
              onClick={() => window.open('https://www.instagram.com/metalearners.shop', '_blank')}
            >
              <Instagram className="w-4 h-4 mr-2" />
              Contact on Instagram
            </Button>
          </div>

          {/* Mobile Menu Button */}
          <button
            className="md:hidden text-foreground"
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          >
            {isMobileMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>

        {/* Mobile Menu */}
        {isMobileMenuOpen && (
          <div className="md:hidden glass-card mt-2 rounded-lg p-4 space-y-4">
            <button
              onClick={() => scrollToSection('offers')}
              className="block w-full text-left text-sm font-medium text-muted-foreground hover:text-foreground transition-colors py-2"
            >
              Offers
            </button>
            <button
              onClick={() => scrollToSection('how-it-works')}
              className="block w-full text-left text-sm font-medium text-muted-foreground hover:text-foreground transition-colors py-2"
            >
              How it works
            </button>
            <button
              onClick={() => scrollToSection('trust')}
              className="block w-full text-left text-sm font-medium text-muted-foreground hover:text-foreground transition-colors py-2"
            >
              Why trust us
            </button>
            <button
              onClick={() => scrollToSection('faq')}
              className="block w-full text-left text-sm font-medium text-muted-foreground hover:text-foreground transition-colors py-2"
            >
              FAQ
            </button>
            <button
              onClick={() => scrollToSection('contact')}
              className="block w-full text-left text-sm font-medium text-muted-foreground hover:text-foreground transition-colors py-2"
            >
              Contact
            </button>
            <Button
              className="w-full bg-primary hover:bg-primary-glow text-primary-foreground shadow-elegant font-medium"
              onClick={() => window.open('https://www.instagram.com/metalearners.shop', '_blank')}
            >
              <Instagram className="w-4 h-4 mr-2" />
              Contact on Instagram
            </Button>
          </div>
        )}
      </div>

      {/* Pay After Activation Banner */}
      <div className="bg-accent/20 border-b border-accent/30 py-2">
        <p className="text-center text-xs md:text-sm text-foreground/90 font-medium">
          ✓ Pay after activation • Full support • Fast delivery
        </p>
      </div>
    </nav>
  );
};
